import { getBreakpointMediaQuery, MediaOption } from "@store/Framework/Common/Utilities/mediaQueries";
import { StyledTheme } from "@store/Framework/Types/StyledTheme";
import { css, FlattenInterpolation, ThemedStyledProps } from "styled-components";

export type BreakpointValue<T = string | 0> = T | null;
export type BreakpointValueProp<T = string | 0> = T | BreakpointValue<T>[];

export type CssBreakpointValue = BreakpointValue | number | FlattenInterpolation<any>;
export type BreakpointValueProperties = null | string | string[];

export default (
    values: CssBreakpointValue[] | undefined | null,
    properties?: BreakpointValueProperties,
    option: MediaOption = "up",
) => {
    return (props: ThemedStyledProps<{}, StyledTheme>) => {
        if (!props.theme || !values) {
            return null;
        }

        const { keys } = props.theme.breakpoints;
        const _properties = typeof properties === "string" ? [properties] : properties;

        return css`
            ${values.map((value, index) => {
                const key = keys[index];

                if ((!value && value !== 0) || !key) {
                    return null;
                }

                const mediaQuery = getBreakpointMediaQuery(key, option, props.theme.breakpoints);
                const result = _properties?.length
                    ? _properties.reduce((rest, property) => `${rest}${property}:${value};`, "")
                    : value;

                if (mediaQuery) {
                    return css`
                        ${mediaQuery} {
                            ${result}
                        }
                    `;
                }

                return css`
                    ${result}
                `;
            })}
        `;
    };
};
